import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'resolveLabel',
  pure: false
})
export class ResolveLabelPipe implements PipeTransform {
  transform<T>(value: T | (() => T)): T {
    return typeof value === 'function' ? (value as () => T)() : value;
  }
}
